class FacilityListing extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['section', 'trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.scrollToSection.bind(this))
    })
  }

  scrollToSection (event) {
    const currentEl = event.target.closest(this.els?.trigger?.selector)

    const section = this.els?.section?.elements.find(
      (sectionEl) => sectionEl.dataset.section === currentEl.dataset.section,
    )

    if (section) {
      this.updateAriaHidden(section)

      section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  updateAriaHidden (visibleSection) {
    this.els?.section?.elements.forEach((sectionEl) => {
      sectionEl.setAttribute(
        'aria-hidden',
        sectionEl === visibleSection ? 'false' : 'true',
      )
    })

    window.BAO.dispatchEvent(window.BAO.EVENTS.TAB_CHANGE.SWAPPED)
  }
}

if (!customElements.get('facility-listing')) {
  customElements.define('facility-listing', FacilityListing)
}
